import { RootState } from 'src/redesign/app/store';

export const isRoleSelectionVisibleSelector = (state: RootState) =>
  state.helpBubble?.isRoleSelectionVisible || false;

export const isAttendeeTicketsModalVisibleSelector = (state: RootState) =>
  state.helpBubble?.isAttendeeTicketsModalVisible || false;
